import baseapi from "./../baseAPI";

export const RemarkListAPI = async (setRemarks, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/caller/remarks?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.remarks);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setRemarks(response.data.remarks.data);
        setLoading(false);

        if(response.data.remarks.data.length > 0)
        {
            //console.log('Total count====='+response.data.total);
            let pagecount = Math.ceil(response.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    };
}


